<template>
    <v-container class="step-container" v-if="unit && current">
        <c-drop-message
            v-if     = "drag.notAllowed"
            :message ="drag.message"
        />

        <d-attach-confirm
            v-model = "attach.visible"
            :data   = "attach.data"
            @attach = "onAttach"
            @cancel = "onAttachCancel"
        />

        <drop @drop="onDrop" mode="cut" :accepts-type="onAcceptType">
            <v-row class="no-frame" :key="refreshAll">
                <v-col class="step-first-column" style="padding-bottom: 0">
                    <inc-site-down-switch v-model="current.unitDown" v-if="!scheduled" />

                    <f-title :title="'Ereignis'" style="margin-bottom: 12px; margin-top: 4px" v-if="!scheduled" />

                    <v-row class="no-frame">
                        <f-enum-select
                            v-model   = "data.company"
                            :label    = "$t('inc.assessment.company')"
                            :readonly = "readonly"
                            :rules    = "[requiredRule]"
                            module    = "inc"
                            type      = "zuescompanies"
                            :background = "fileEntryFieldBackground"
                        />
                    </v-row>

                    <v-row class="no-frame" v-if="scheduled">
                        <f-enum-select
                            v-model   = "current.type"
                            :label    = "$t('inc.assessment.type')"
                            :readonly = "readonly"
                            :rules    = "[requiredRule]"
                            module    = "inc"
                            type      = "assessmenttypes"
                        />
                    </v-row>

                    <v-row class="no-frame" v-if="scheduled">
                        <div style="height: 50px"></div>
                    </v-row>

                    <inc-status
                        v-model = "current.status"
                        :items  = "step.status"
                        @change = "onStatusChanged"


                    />
                    <msd-users
                        v-model="incident.responsible"
                        :background = "fileEntryFieldBackground"
                    />

                    <v-row class="no-frame" v-if="!scheduled">
                        <v-col class="pa-0 pr-2">
                            <v-text-field
                                :label         = "$t('inc.edit.general.reporter')"
                                v-model        = "data.reporter"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                            />
                        </v-col>
                    </v-row>

                    <v-row class="no-frame" v-if="scheduled">
                        <div style="height: 50px"></div>
                    </v-row>

                    <v-row class="no-frame" v-if = "scheduled">
                        <v-col class="pa-0 pr-2">
                            <f-date-picker
                                v-model   = "current.dateAssessment"
                                label     = "inb.detail.assessment.date"
                                :readonly = "readonly"
                                :rules    = "[requiredRule]"
                                class     = "w-100"
                            />

                            <!--
                            <f-date-picker
                                :label    = "scheduled ? 'inc.assessment.date' : 'inc.edit.common.processing.start'"
                                :time     = "false"
                                v-model   = "current.beginDate"
                                :required = "true"
                                :rules    = "[requiredRule]"
                                class     = "mr-2 w-100"
                                @change   = "onScheduleChanged"
                            />
                        -->
                        </v-col>
                        <v-col class="pa-0 pr-2">
                        </v-col>
                    </v-row>

                    <inc-unit-down-interval
                        v-if      = "!scheduled"
                        :unitdata     = "current"
                        :status       = "current.status"
                    />

                    <c-v-spacer />
                </v-col>
                <v-col class="step-middle-column">
                    <div v-if="!scheduled">
                        <v-row class="no-frame" >
                            <v-col class="pa-0" >
                                <v-switch
                                    v-if="!current.invoiceId"
                                    v-model = "data.invoice"
                                    :label  = "$t('inc.edit.common.invoice')"
                                    @change = "onInvoice"
                                    class   = "pt-0 mt-0"
                                    hide-details
                                />
                                <div v-if="current.invoiceId" class="v-flex">
                                    <c-toolbar-button

                                        class="mt-n1"
                                        icon="mdi-arrow-left-thin-circle-outline"
                                        color="primary"
                                        size="22"
                                        tooltip="Zur ZÜS Rechnung wechseln"
                                        @click="onGotoInvoice"
                                    />
                                    <div style="margin-top: -1px" class="primary--text">
                                        zur Rechnung
                                    </div>

                                </div>
                            </v-col>
                        </v-row>

                        <f-title :title="$t ('inb.detail.assessment.title.main')" style="margin-top: 10px" />
                        <v-row class="no-frame mt-3">
                            <f-enum-select
                                v-model   = "current.type"
                                :label    = "$t('inc.assessment.type')"
                                :readonly = "readonly"
                                :rules    = "[ requiredRule ]"
                                module    = "inc"
                                type      = "assessmenttypes"
                            />
                        </v-row>

                        <v-row class="no-frame">
                            <v-col class="pa-0 pr-2">
                                <f-enum-select
                                    v-model   = "current.result"
                                    :label    = "$t('inc.assessment.result')"
                                    :readonly = "readonly"
                                    :rules    = "[ requiredAfterExecution ]"
                                    module    = "inc"
                                    type      = "assessmentresults"
                                    @input    = "validate"
                                />
                            </v-col>
                            <v-col class="pa-0 pl-2">
                                <f-date-picker
                                    v-model   = "current.dateAssessment"
                                    label     = "inb.detail.assessment.date"
                                    :readonly = "readonly"
                                    :rules    = "[ requiredAfterExecution ]"
                                    class     = "w-100"
                                    @change   = "onAssessmentDate"
                                />
                            </v-col>
                        </v-row>

                        <v-row class="no-frame">
                            <v-col class="pa-0 pr-2">
                                <div class="v-flex" v-if="nextDateRequired">
                                    <f-date-picker
                                        v-model = "current.dateNextAssessment"
                                        :rules  = "[ requiredAfterExecution, nextDateLessThanDateRemedyOfDefects ]"
                                        label   = "inb.detail.assessment.dateNext"
                                        class   = "w-100"
                                    />

                                    <v-btn
                                        v-if   = "current.nextAssessment"
                                        color  = "primary"
                                        @click = "onGoto (data.nextAssessment.id)"
                                        class  = "mt-3 ml-2"
                                        x-small
                                        fab
                                        depressed
                                        outlined
                                    >
                                        <i class="fas fa-chevron-right white--text"></i>
                                    </v-btn>
                                </div>
                            </v-col>
                            <v-col class="pa-0 pl-2">
                                <div class="v-flex">
                                    <f-date-picker
                                        v-model = "current.dateRemedyOfDefects"
                                        label   = "inb.detail.assessment.dateRemedy"
                                        :rules  = "[ requiredOnDefects, dateRemedyOfDefectsGreaterThanNextDate ]"
                                        class   = "w-100"
                                    />

                                    <v-btn
                                        v-if   = "current.nextReview"
                                        color  = "primary"
                                        @click = "onGoto (data.nextReview.id)"
                                        class  = "mt-3 ml-2"
                                        fab
                                        depressed
                                        outlined
                                        x-small
                                    >
                                        <i class="fas fa-chevron-right white--text"></i>
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>

                        <f-title :title="$t('inb.detail.assessment.title.contact')" style="margin-top: 20px"/>

                        <v-row class="no-frame mt-5" >
                            <v-col class="pa-0 pr-2">
                                <v-text-field
                                    v-model = "current.contactName"
                                    :label  = "$t('inb.detail.assessment.contact.name')"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                />
                            </v-col>
                        </v-row>
                        <v-row class="no-frame">
                            <v-col class="pa-0 pr-2">
                                <v-text-field
                                    v-model = "current.contactPhone"
                                    :label  = "$t('inb.detail.assessment.contact.phone')"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                />
                            </v-col>
                            <v-col class="pa-0 pl-2">
                                <v-text-field
                                    v-model = "current.contactMobile"
                                    :label  = "$t('inb.detail.assessment.contact.mobile')"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                />
                            </v-col>
                        </v-row>
                        <v-row class="no-frame">
                            <v-col class="pa-0 pr-2">
                                <v-text-field
                                    v-model = "current.contactMail"
                                    :label  = "$t('inb.detail.assessment.contact.mail')"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                />
                            </v-col>
                        </v-row>
                    </div>
                </v-col>

                <v-col class="step-middle-column" style="padding-right: 5px">
                    <div v-if="!scheduled" style="height: 100%">
                        <f-title :title="$t('inb.detail.assessment.title.defects')" style="margin-top: 34px; margin-right: 12px" />
                        <inc-assessment-faults
                            :faults = "current.faults"
                            :result = "current.result"
                            :height = "540"
                            @change = "onFaults"
                        />
                    </div>
                </v-col>

                <v-col class="step-last-column">
                    <crm-journal
                        :incident = "incident"
                        @front   ="onJournalFront"
                        style="margin-top: -5px" />
                </v-col>
            </v-row>
        </drop>
   </v-container>
</template>

<script>

import Core                  from "@/modules/core/service/Core";
import Inc                   from "@/modules/inc/service/Inc.js";
import Inb                   from "@/modules/inb/service/Inb.js";
import Mail                  from "@/modules/inc/mail/service/Mail";
import CrmJournal            from "@/modules/crm/components/main/CrmJournal.vue";
import FTitle                from "@/modules/core/components/utils/FTitle.vue";
import IncSiteDownSwitch     from "@/modules/inc/steps/components/common/IncSiteDownSwitch.vue";
import MsdUsers              from "@/modules/msd/user/components/controls/MsdUsers.vue";
import IncStatus             from "@/modules/inc/steps/components/common/IncStatus.vue";
import IncAssessmentFaults   from "@/modules/inc/steps/components/assessment/IncAssessmentFaults.vue";
import FDatePicker           from "@/modules/core/components/utils/FDatePicker.vue";
import { Drop }              from "vue-easy-dnd"
import CVSpacer              from "@/modules/core/components/utils/CVSpacer.vue";
import FEnumSelect           from "@/modules/core/components/utils/FEnumSelect.vue";
import IncUnitDownInterval from "@/modules/inc/steps/components/common/IncUnitDownInterval.vue";
import StepMixin from "@/modules/inc/steps/components/mixins/StepMixin";
import CDropMessage from "@/modules/inc/steps/components/common/CDropMessage.vue";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";
import DAttachConfirm from "@/modules/inc/steps/components/common/DAttachConfirm.vue";

export default {
    name : "IncAssessment",

    mixins: [
        StepMixin
    ],

    components: {
        DAttachConfirm,
        CToolbarButton,
        CDropMessage,
        IncUnitDownInterval,
        FEnumSelect,
        CVSpacer,
        IncAssessmentFaults,
        CrmJournal,
        FTitle,
        IncSiteDownSwitch,
        MsdUsers,
        IncStatus,
        FDatePicker,
        Drop
    },

    props: {
        incident: {
            required: true,
            type: Object,
            default: function () {
                return {
                    responsible   : null,
                    beginDate     : null,
                    endDate       : null,
                    nextAssessment: null,
                    nextReview    : null,
                }
            }
        },

        changes: {
            type: Function,
        },

        data: {
            required: true,
            type: Object,
            refresh: 0,
            default: function () {
                return {
                    executionDate: null,
                    reporter: null
                }
            }
        },
    },

    data: () => ({
        drag: {
            notAllowed: false,
            message   : null
        },

        attach: {
            visible: false,
            data   : null
        },

        scheduleDate   : null,
        refreshAll     : 0,
        event: null,
    }),

    created() {
        this.$bus.$on(this.$events.drag.end, this.onDragend);
    },

    beforeDestroy() {
        this.$bus.$off(this.$events.drag.end, this.onDragend);
    },

    mounted() {
        this.form = this.$parent;

        this.$nextTick(() => {
            this.form.validate();
            this.initBase();
        });
    },

    watch: {
        dateNextAssessment () {
            this.$nextTick(() => {
                this.validate().then(() => {
                    this.$emit("validated")
                });
            });
        },

        dateRemedyOfDefects () {
            this.$nextTick(() => {
                this.validate().then(() => {
                    this.$emit("validated")
                });
            });
        },
    },

    computed: {
        dateNextAssessment () {
            return this.data.dateNextAssessment;
        },

        dateRemedyOfDefects () {
            return this.data.dateRemedyOfDefects;
        },

        requiredRule () {
            return Core.rule.required;
        },

        invoice () {
            return this.incident.data[this.index+1];
        },

        repair () {
            return this.incident.data[this.index+2];
        },

        repairInvoice () {
            return this.incident.data[this.index+3];
        },

        scheduled () {
            if (!this.current) {
                return false;
            }

            return Inc.status.scheduled.includes (this.current.status.id);
        },

        fileEntryFieldBackground () {
            return Inc.style.fileEntryFieldBackground(this.data);
        },

        nextDateRequired () {
            if (!this.current || !this.current.type) {
                return true;
            }

            return this.current.type.id !== 'REVIEW' && this.current.type.id !== 'FIRE_ELEVATOR';
        }
    },

    methods: {
        _validate () {
            if (!this.unit) {
                return;
            }

            this.current.valid = this.form.validate();
            let valid = true;
            this.data.collection.forEach(data => {
                if (!data.valid) {
                    valid = false;
                }
            })

            this.valid = valid;
        },

        /**
         * Sets the given unit als new context for the processing step. The visibility of other processing steps and
         * will be adopted to the given unit.
         *
         * @param unit the new unit context.
         */
        _setContext (unit) {
            this.unit = unit;
            this.setVisibility ();
            this.scheduleDate = this.current.dateAssessment;
        },

        /**
         * Checks if the current processing step in the current context is terminated.
         * @returns true, if the processing step is terminated, false otherwise.
         */
        _isTerminated () {
            if (!this.current) {
                return false;
            }

            return this.current.status.type === 'T';
        },

        _status () {
            if (!this.current) {
                return null;
            }

            return this.current.status;
        },

        /**
         * Force an update of relevat componets. E.g. when the list of assigned sites changes.
         */
        _forceUpdate () {
            this.setVisibility();
            this.freeze = JSON.stringify(this.data);
            this.scheduleDate = this.data.beginDate;
        },

        _unitStepStatus (unit) {
            const current = this.data.collection.find (s => s.unit.id === unit.id);
            if (!current) {
                return null;
            }

            return current.valid ? "success" : "error";
        },

        _unitDownResolved (event) {
            this.event = event;
            this.confirmUnitDownResolved = true;
        },

        /**
         * Validate the processing step and inform the main dialog about a possible change.
         */
        validate () {
            return this.$nextTick().then(() => {
                this._validate();
                return Promise.resolve();
            })
        },

        /**
         * Checks if an input value is required auft the assessment was executed.
         * @param value the current input value
         */
        requiredAfterExecution (value) {
            if (Inc.status.scheduled.includes (this.current.status.id)) {
                return true;
            }

            if (value === undefined || value === null || value.length === 0) {
                return this.$t('rules.required');
            }

            return true;
        },

        nextDateLessThanDateRemedyOfDefects (value) {
            if (!value) {
                return true;
            }

            if (!this.current.dateRemedyOfDefects) {
                return true;
            }

            if (this.current.dateNextAssessment > this.current.dateRemedyOfDefects) {
                return true;
            }

            return this.$t('inc.assessment.error.nextDates');
        },

        dateRemedyOfDefectsGreaterThanNextDate (value) {
            if (!value) {
                return true;
            }

            if (!this.current.dateNextAssessment || this.current.type.id === 'REVIEW') {
                return true;
            }

            if (this.current.dateRemedyOfDefects <= this.current.dateNextAssessment) {
                return true;
            }

            return this.$t('inc.assessment.error.nextDates');
        },

        /**
         * Checks if an error exists, that makes a review necessary
         * @param value the current input value
         */
        requiredOnDefects (value) {
            if (!this.current.result) {
                return true;
            }

            if (!["MAJOR", "DANGER", "CANCELED"].includes(this.current.result.id)) {
                return true;
            }

            if (value === undefined || value === null || value.length === 0) {
                return this.$t('rules.required');
            }

            return true;
        },

        /**
         * Checks whether a message can be attached to the current processing step.
         * @param dragData the message
         * @return true, if the message can be attached to the step.
         */
        onAcceptType (dragData) {
            if (!(dragData instanceof Object) || dragData.type === "dms-document") {
                return;
            }

            const accept = Inc.clipboard.accept(dragData, this.incident, [{
                message : "ASSESSMENT",
                incident: null
            }, {
                message : "ORDER",
                incident: null
            }, {
                message : "ASSESSMENTAPOINTMENT",
                incident: null
            },{
                message : "TZB",
                incident: null
            }, {
                message : "DEFAULT",
                incident: null
            }, {
                message: "WORKREPORT",
                incident: null
            }, {
                message: "IMAGE",
                incident: null
            },{
                message: "CORRESPONDENCE",
                incident: null
            },
            ], true, true);

            this.drag.notAllowed = !accept.valid;
            this.drag.message    = this.$t(accept.message);

            return accept.valid;
        },

        /**
         * Attaches a message to the processing step.
         * @param event the drag'n drop element that contains the message,
         */
        onDrop (event) {
            switch (event.data.type) {
                case 'clipboard':
                    Inc.clipboard.paste (this, event.data.data.id, event.data.data.unit, this.incident.id, this.changes());
                    break;
                case 'inbox':
                    if (this.overwritesData(event.data.data)) {
                        this.attach.data = event.data.data;
                        this.attach.visible = true;
                    } else {
                        this.attachMessage(true, event.data.data);
                    }
            }
        },

        onAttach (event) {
            this.attachMessage(event.overwrite, event.data);
        },

        onAttachCancel () {
            this.attach.visible = false;
        },

        onDragend () {
            this.drag.notAllowed = false;
        },

        onInvoice () {
            this.invoice.visible = this.data.invoice;
            this.$emit("save");
        },

        onGotoInvoice () {
            this.$emit("save", () => {
                Inc.goto(this, this.current.invoiceId, this.unit.id)
            });
        },

        onGoto (incidentId) {
            Inc.goto(this, incidentId);
        },

        onFaults (faults) {
            this.data.faults = faults;
        },

        onAssessmentDate () {
            if (!this.scheduleDate) {
                this.scheduleDate = this.current.dateAssessment;
            }
        },

        getMail () {
            return Mail.initialize(this.incident.sites, this.index, this.data, this.current, this.incident, this.step);
        },

        setVisibility () {
            if (!this.current) {
                return;
            }

            this.repair.visible  = Inc.status.terminatedWithRepair.includes (this.current.status.id);
            this.invoice.visible = !Inc.status.scheduled.includes(this.current.status.id) && this.data.invoice && !this.current.invoiceId;

            if (!this.repair.visible) {
                this.repairInvoice.visible = false;
            } else {
                this.repairInvoice.visible = this.repair.invoice;
            }
        },

        overwritesData (message) {
            console.log("overwrites", message)

            return !!this.current.dateAssessment
                || !!this.current.dateNextAssessment
                || !!this.current.dateRemedyOfDefects
                || !!this.current.result
                || !!this.current.type
                || (this.current.faults && this.current.faults.length > 0)
            ;
        },

        attachMessage (overwrite, data) {
            Inb.attach(this, data.id, this.incident.id, this.step, null, overwrite,(message) => {
                this.$emit("refresh", message);
            });
        }
    }
}
</script>
